import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import './detailstyle.css';
import './style.css';
import ProductDetails from './ProductDetails';
import {
  Link
} from "react-router-dom";

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    overflow: "visible",
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};

const Product = (props) => {

  // eslint-disable-next-line
  const products = props.products
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [product, setProduct] = useState([])
  const [showProduct, setShowProduct] = useState(false)
  const [currentProductIndex, setCurrentProductIndex] = useState(0)

  const setProductState = (productvalue, Index) => {
    setProduct(productvalue)
    setCurrentProductIndex(Index)
    setShowProduct(true)
  }

  useEffect(() => {
    Modal.setAppElement('body');
    setProductState(props.product, props.Index)
  }, []);

  const openModal = () => {
    setModalIsOpen(true)
  }

  const closeModal = () => {
    setProductState(props.product, props.Index)
    setModalIsOpen(false)
  }

  const changeProductDetails = (product_id) => {
    setModalIsOpen(false)
    props.changeProduct(product_id)
  }


  const addToCart = (id, variantQuantity) => {
    setModalIsOpen(false)
    props.addVariantToCart(id, variantQuantity)
  }

  const nextProduct = () => {
    setShowProduct(false)
    let Index = currentProductIndex + 1;
    setProductState(products[Index], Index)
  }

  const prevProduct = () => {
    setShowProduct(false)
    let Index = currentProductIndex - 1;
    setProductState(products[Index], Index)
  }

  const changeImageOnHover = (event) => {
    if (props.product.images.length > 1) {
      event.target.src = props.product.images[1].src
    }
  }

  const changeImageOnMouseOut = (event) => {
    if (props.product.images.length > 0) {
      event.target.src = props.product.images[0].src
    }
  }

  if (showProduct) {
    return (
      <div className={props.isproductForSlide ? "main_container1" : "main_container col-md-4 col-sm-6"}>
        <div className="Product_view_modal">
          <Link to={{ pathname: "/ProductDetail/" + props.category, search: "?id=" + props.product.id.toString() }}
            onClick={() => props.isproductForSlide ? changeProductDetails(props.product.id) : null} className="desktop_views">
            {product.images.length ? <img className={props.isproductForSlide ? "Product_image1" : "Product_image"}
            src={props.product.images[0].src} onMouseOver={changeImageOnHover}
              onMouseOut={changeImageOnMouseOut} alt={`${props.product.title} product shot`} /> : null}
          </Link>

          <div className="mobile_views">
            {product.images.length ? <img className={props.isproductForSlide ? "Product_image1" : "Product_image"}
             src={props.product.images[0].src} onMouseOver={changeImageOnHover}
              onMouseOut={changeImageOnMouseOut} alt={`${props.product.title} product shot`} /> : null}
          </div>
          <div className="overlay"></div>
          <div className="button_view" onClick={openModal}> Quick View </div>
        </div>
        <h5 className="Product__title desktop_views">{props.product.title} </h5>

        <Link to={{ pathname: "/ProductDetail/" + props.category, search: "?id=" + props.product.id.toString() }}
            onClick={() => props.isproductForSlide ? changeProductDetails(props.product.id) : null}>
         <h5 className="Product__title mobile_views">{props.product.title}</h5>
          </Link>
       

        <span className="Product__price">$ {props.product.variants[0].price.amount}</span>
        <div className="container">
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Detail Modal"
            style={customStyles} >
            <ProductDetails
              category={props.category}
              productsCount={products.length}
              Index={currentProductIndex}
              addVariantToCart={props.addVariantToCart}
              client={props.client}
              product={product}
              addToCart={addToCart}
              closeModal={closeModal}
              openModal={openModal}
              isproductForSlide={props.isproductForSlide}
              changeProduct={changeProductDetails}
              nextProduct={nextProduct}
              prevProduct={prevProduct}
            />
          </Modal>
        </div>
      </div>
    );
  } else {
    return (
      <div>Loading</div>
    );
  }

}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js